<template>
  <div class="detail_container">
    <slot></slot>
  </div>
</template>

<script setup></script>

<style scoped>
.detail_container {
  width: 100%;
  min-height: 300px;
  background-color: white;
  box-shadow: 1px 0 4px 0px rgb(201, 201, 201);
  flex: 1;
  padding: 20px;
  overflow: auto;
}
</style>
